import { trustQuotes } from '../content';
import { siteConfig } from '../../../shared/config/site';

export function TrustSection() {
  return (
    <section id="trust" className="defer-render relative bg-surface py-[var(--section-padding-y)]" aria-labelledby="trust-heading">
      <div className="mx-auto max-w-[var(--container-max)] px-[var(--section-padding-x)]">
        <div className="flex flex-col gap-8 border-b border-neutral-200 pb-14 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="section-eyebrow">Reviews</p>
            <h2 id="trust-heading" className="section-title">
              What Midrand owners say
            </h2>
            <p className="section-copy max-w-lg">
              An SAVC-registered practice. {siteConfig.veterinarianOwner} owns and leads it, alongside{' '}
              {siteConfig.veterinarianTeam}.
            </p>
          </div>
          <div className="lg:text-right">
            <p className="font-display text-6xl font-semibold leading-none text-primary-700 sm:text-7xl">
              {siteConfig.ratingValue}
            </p>
            <a
              href={siteConfig.reviewsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-1 inline-flex min-h-11 items-center font-body text-sm text-neutral-600 underline decoration-neutral-300 underline-offset-4 transition-[color,text-decoration-color] duration-200 ease-in-out hover:text-ink hover:decoration-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink"
            >
              from {siteConfig.reviewCount} Google reviews
            </a>
          </div>
        </div>

        <div className="mt-2 divide-y divide-neutral-200">
          {trustQuotes.map((item) => (
            <figure key={item.name} className="grid gap-6 py-12 lg:grid-cols-[1fr_11rem] lg:gap-20">
              <blockquote className="font-display text-2xl font-medium leading-snug tracking-tight text-ink sm:text-3xl">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="lg:pt-2 lg:text-right">
                <cite className="font-body text-sm font-semibold not-italic text-ink">{item.name}</cite>
                <p className="mt-1 font-body text-xs uppercase tracking-[0.18em] text-neutral-500">{item.date}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
